import config from '../../../config.json'
import WrapperPageSimple from '../../WrapperPage/present/WrapperPageSimple'
import RequestOverlayContainer from '../../overlay/container/RequestOverlayContainer'
import Translation from '../../Translation/cont/Translation'
import FetchProgramButton from '../../PageProgram/FetchProgramButton'
import SaveStateButton from '../../general/SaveStateButton'
import EditAllMoviesList from './EditAllMoviesList'
import ButtonLink from '../../general/ButtonLink'
import OverlaySaveProgramComponent from '../../overlay/presentational/OverlaySaveProgramComponent'

const PageEditAllMoviesPage = ({
    pageTitleTransId,
    goBackPath,
    movies,
    moviesOrder,
    metaMovies,
    hasUpdates,
    movieMappings,
    tmdbMovies,
    isSticky,
    listHeaderRef,
    programStatus,
    programError,
    onGetProgram,
    onFetchProgram,
    onUpdateProgramRedirect,
    onUpdateProgram,
    onNavigate,
    handleScroll
}) => (
    <WrapperPageSimple
        pageTitleTransId={pageTitleTransId}
        closePagePath={goBackPath ? goBackPath : config.routes.website.path}
        addClassName="edit-all-items edit-all-movies"
        overlay={
            goBackPath ? (
                <OverlaySaveProgramComponent
                    titleTransId="program_save_overlay_title"
                    textTransId="program_save_overlay_text"
                    buttonPublishTransId="publish_program_button"
                    buttonGetTransId="discard_program_button"
                    onGetProgram={onGetProgram}
                    onUpdateProgram={onUpdateProgramRedirect}

                />
            ) : (
                <RequestOverlayContainer
                    programStatus={programStatus} 
                    programError={programError}
                />
            )
        }
        handleScroll={handleScroll}
    >
        <div className="program-page program-page-edit-selection site-content">

            <FetchProgramButton
                buttonTransId='fetch_program'
                hasUpdates={hasUpdates}
                onFetchProgram={onFetchProgram}
            />

            <div className="selections-item">
                <div className="selections-item header-accordion-item-open single-section">
                    <div className="selections-item-content accordion-item">
                        <div className="full-sections">

                            <ButtonLink
                                className="button-sorting-movies"
                                spanClassName="button-text"
                                transId="movie_sort_movies"
                                text="Sortierung"
                                hideText={false}
                                pathname={`${config.routes.movies.path}/sort-items`}
                            />

                            {movies ? (
                                <div>
                                    <EditAllMoviesList
                                        movies={movies}
                                        moviesOrder={moviesOrder}
                                        metaMovies={metaMovies}
                                        movieMappings={movieMappings}
                                        tmdbMovies={tmdbMovies}
                                        listHeaderRef={listHeaderRef}
                                        isSticky={isSticky}
                                        onNavigate={onNavigate}
                                    />
                                    
                                    <div className="save-program-button">
                                        <SaveStateButton
                                            status={programStatus}
                                            transId="publish_program_button"
                                            condition={true}
                                            saveState={onUpdateProgram}
                                        />
                                    </div>
                                </div>
                            ) : (
                                <div className="program-page site-content">
                                    <div><Translation id="click_on_fetch" /></div>
                                    <div><Translation id="log_in_and_out" /> <a className="support-mail text-regular-color cursor-pointer" href="mailto:support@pmkino.com"><Translation id="support"/></a></div>
                                </div>
                            )} 
                        </div>
                    </div>
                </div>
            </div>
        
        </div>
    </WrapperPageSimple>
)

export default PageEditAllMoviesPage